import React from "react";
import { Table, Select, Typography, Pagination } from "antd";
import { COLORS, DirectoryItem } from "../types/types";
import { columns as getColumns } from "./TableColumns";

const { Text } = Typography;

interface DirectoryTableProps {
  users: DirectoryItem[];
  totalItems: number;
  currentPage: number;
  pageSize: number;
  activeTab: string;
  onPageChange: (page: number, pageSize?: number) => void;
  onPageSizeChange: (current: number, size: number) => void;
}

const DirectoryTable: React.FC<DirectoryTableProps> = ({
  users,
  totalItems,
  currentPage,
  pageSize,
  activeTab,
  onPageChange,
  onPageSizeChange,
}) => {
  const columns = getColumns(activeTab);

  return (
    <>
      <div style={{ marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Text style={{ color: COLORS.textLight }}>
          <span style={{ color: "black", fontWeight: "bold", fontSize: "16px" }}>
            {totalItems} professionnel(s) au total •{" "}
          </span>
          {users.length !== totalItems && (
            <span>{users.length} affiché{users.length === 1 ? "" : "s"} après filtre • </span>
          )}
        </Text>
        
        <Select
          value={pageSize}
          onChange={(value) => onPageSizeChange(currentPage, value)}
          style={{ width: 120 }}
          options={[
            { value: 25, label: '25 / page' },
            { value: 50, label: '50 / page' },
            { value: 100, label: '100 / page' },
            { value: 200, label: '200 / page' },
          ]}
        />
      </div>
      
      <Table
        dataSource={users}
        columns={columns}
        rowKey="id"
        pagination={false}
        scroll={{ x: 1000, y: 500 }}
        size="middle"
      />

      <div style={{ marginTop: 24, display: "flex", justifyContent: "center" }}>
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={totalItems}
          onChange={onPageChange}
          showSizeChanger={false}
          showQuickJumper
          showTotal={(total) => `Total ${total} professionnels`}
        />
      </div>
    </>
  );
};

export default DirectoryTable;